import clsx from 'clsx';
import { toReadablePrice } from 'lib/utils';

import stonks from 'assets/images/stonks.svg';
import notStonks from 'assets/images/not-stonks.svg';
import styles from './styles.module.scss';

type PriceDynamicsProps = {
  variant: 'up' | 'down';
  price?: number;
  className?: string;
};

const PriceDynamics: React.FC<PriceDynamicsProps> = (props) => {
  const { variant, price, className } = props;

  const up = variant === 'up';
  const withPrice = price !== undefined;

  return (
    <span
      className={clsx(
        styles.container,
        up ? styles.up : styles.down,
        withPrice && styles.withPrice,
        className,
      )}
    >
      <img
        width={16}
        height={16}
        src={up ? stonks : notStonks}
        alt={up ? 'Иконка увеличения цены' : 'Иконка уменьшения цены'}
      />

      {withPrice && toReadablePrice(price)}
    </span>
  );
};

export default PriceDynamics;
